import React from "react"
import { Link } from "gatsby"
import Pages from "../data/seo-meta"

import linkedInLogo from "../images/common/icon-linkedin.png"
import youtubeLogo from "../images/common/icon-youtube.png"

const socials = [
  {
    img: linkedInLogo,
    alt: "Slice on LinkedIn",
    link: "https://linkedin.com/company/slice-labs-inc-/",
  },
  {
    img: youtubeLogo,
    alt: "Slice on Youtube",
    link: "https://www.youtube.com/channel/UCzAWI2DZiTrLqBKThIvtlLw",
  },
]

const Footer = () => {
  const headerClass = "text-[1.8rem] leading-[3.2rem] font-semibold uppercase"
  const linkClass = "p2"

  return (
    <footer>
      <section className="bg-[#f8f8f8]">
        <div className="container">
          <div className="flex content-between pt-32 pb-24 flex-wrap md:flex-nowrap">
            <div className="md:w-1/2">
              <p className="h1 max-w-[46rem]">
                Are you ready to get quoting with Slice?
              </p>
            </div>
            <div className="md:w-1/2">
              <p className="p1 max-w-[44rem] pb-8">
                Access your quotes anytime—save, retrieve, and bind with ease.
              </p>
              <p className="p3 font-bold flex flex-wrap gap-4 text-[--slice-primary]">
                <a
                  className="btn bg-white hover:drop-shadow min-w-[15.5rem]"
                  href={Pages.AgentPlatformMeta.path}
                  target="_blank"
                  rel="nofollow noreferrer"
                >
                  Create an account{" "}
                  <i className="fa-solid fa-arrow-right ml-2"></i>
                </a>
                <a
                  className="btn text-white bg-[--slice-primary] hover:drop-shadow min-w-[15.5rem]"
                  href={Pages.AgentPlatformMeta.path}
                  target="_blank"
                  rel="nofollow noreferrer"
                >
                  Agent Login <i className="fa-solid fa-arrow-right ml-2"></i>
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="bg-footer text-white p2">
        <div className="container">
          <div className="text-right pt-10">
            <a href="#nav_top">Back to top</a>
          </div>
          <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-4">
            <ul className="pt-6">
              <li className={headerClass}>Contact</li>
              <li className={linkClass}>33 Irving Place, Suite 7116</li>
              <li className={linkClass}>New York, NY 10003 USA</li>
              <li>&nbsp;{/* spacer */}</li>
              <li className={linkClass}>
                <a href="mailto:info@sliceinsurance.com">
                  info@sliceinsurance.com
                </a>
              </li>
              <li className={linkClass}>
                <a href="tel:18666675423">1‑866‑667‑5423</a>
              </li>
            </ul>
            <ul className="pt-6">
              <li className={headerClass}>Company</li>
              {Pages.Sitemap.Corporate.map((item) => (
                <li className={linkClass} key={item.path}>
                  {item.external ? (
                    <a href={item.path} rel="nofollow noreferrer">
                      {item.title}
                    </a>
                  ) : (
                    <Link to={item.path}>{item.title}</Link>
                  )}
                </li>
              ))}
            </ul>
            <ul className="pt-6">
              <li className={headerClass}>Industry</li>
              {Pages.Sitemap.Industry.map((item) => (
                <li className={linkClass} key={item.path}>
                  <Link to={item.path}>{item.title}</Link>
                </li>
              ))}
            </ul>
            <ul className="pt-6">
              <li className={headerClass}>Product</li>
              {Pages.Sitemap.Product.map((item) => (
                <li className={linkClass} key={item.path}>
                  <Link to={item.path}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex pt-8 pb-20 items-end">
            {socials.map((social) => (
              <a
                href={social.link}
                rel="nofollow noreferrer"
                target="_blank"
                key={social.link}
              >
                <img className="mr-8" src={social.img} alt={social.alt} />
              </a>
            ))}
          </div>
        </div>
        <div className="bg-black py-8">
          <div className="container divide-y">
            <p className="pb-6">
              &copy; Slice Insurance Technologies Inc {new Date().getFullYear()}{" "}
              - Insurance Services provided by Slice Insurance Technologies Inc.
            </p>
            <ul className="flex flex-col md:flex-row md:divide-x pt-6">
              {Pages.Sitemap.Legal.map((item) => (
                <li className="md:px-4 md:first:pl-0" key={item.path}>
                  <Link to={item.path}>{item.title}</Link>
                </li>
              ))}
              <li className="md:pl-4">
                <Link to={Pages.SitemapMeta.path}>Sitemap</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
